"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassificationRuleMapper = void 0;
const cel_1 = require("@groupby/enrich-criteria/cel");
const stdlib_core_1 = require("@groupby/stdlib-core");
const jsonapi_utils_1 = require("../../../#core/jsonapi-utils");
class ClassificationRuleMapper {
    toClassificationRule(resource) {
        return {
            id: resource.id,
            createdAt: new Date(resource.attributes.createdAt),
            updatedAt: new Date(resource.attributes.updatedAt),
            createdBy: jsonapi_utils_1.pluckRelationshipId(resource.relationships.user),
            name: resource.attributes.name,
            productFilter: cel_1.parse(resource.attributes.productFilter),
            classId: jsonapi_utils_1.pluckRelationshipId(resource.relationships.class),
            organizationIds: jsonapi_utils_1.pluckRelationshipIds(resource.relationships.organizations),
            enabled: resource.attributes.enabled,
        };
    }
    toClassificationRuleResource(entity) {
        return {
            id: entity.id,
            type: 'ClassificationRule',
            attributes: {
                createdAt: entity.createdAt.toISOString(),
                updatedAt: entity.updatedAt.toISOString(),
                name: entity.name,
                productFilter: cel_1.format(entity.productFilter),
                enabled: entity.enabled,
            },
            relationships: {
                class: jsonapi_utils_1.createRelationship(entity.classId, (id) => ({ type: 'Class', id })),
                user: jsonapi_utils_1.createRelationship(entity.createdBy, (id) => ({ type: 'User', id })),
                organizations: jsonapi_utils_1.createRelationships(entity.organizationIds, (id) => ({ type: 'Organization', id })),
            },
        };
    }
    toClassificationRuleCreation(resource) {
        return {
            name: resource.attributes.name,
            productFilter: cel_1.parse(resource.attributes.productFilter),
            classId: jsonapi_utils_1.pluckRelationshipId(resource.relationships.class),
            organizationIds: jsonapi_utils_1.pluckRelationshipIds(resource.relationships.organizations),
            enabled: resource.attributes.enabled,
        };
    }
    toClassificationRuleResourceCreation(entity) {
        return {
            type: 'ClassificationRule',
            attributes: {
                name: entity.name,
                productFilter: cel_1.format(entity.productFilter),
                enabled: entity.enabled,
            },
            relationships: {
                class: jsonapi_utils_1.createRelationship(entity.classId, (id) => ({ type: 'Class', id })),
                organizations: jsonapi_utils_1.createRelationships(entity.organizationIds, (id) => ({ type: 'Organization', id })),
            },
        };
    }
    toClassificationRuleUpdate(resource) {
        var _a, _b, _c, _d, _e, _f;
        return {
            id: resource.id,
            name: (_a = resource.attributes) === null || _a === void 0 ? void 0 : _a.name,
            productFilter: stdlib_core_1.optionalize(cel_1.parse)((_b = resource.attributes) === null || _b === void 0 ? void 0 : _b.productFilter),
            classId: (_d = stdlib_core_1.optionalize(jsonapi_utils_1.pluckRelationshipId)((_c = resource.relationships) === null || _c === void 0 ? void 0 : _c.class)) !== null && _d !== void 0 ? _d : undefined,
            organizationIds: stdlib_core_1.optionalize(jsonapi_utils_1.pluckRelationshipIds)((_e = resource.relationships) === null || _e === void 0 ? void 0 : _e.organizations),
            enabled: (_f = resource.attributes) === null || _f === void 0 ? void 0 : _f.enabled,
        };
    }
    toClassificationRuleResourceUpdate(entity) {
        return jsonapi_utils_1.normalizeResource({
            type: 'ClassificationRule',
            id: entity.id,
            attributes: {
                name: entity.name,
                productFilter: stdlib_core_1.optionalize(cel_1.format)(entity.productFilter),
                enabled: entity.enabled,
            },
            relationships: {
                class: jsonapi_utils_1.createRelationship(entity.classId, (id) => ({ type: 'Class', id })),
                organizations: jsonapi_utils_1.createRelationships(entity.organizationIds, (id) => ({ type: 'Organization', id })),
            },
        });
    }
}
exports.ClassificationRuleMapper = ClassificationRuleMapper;
//# sourceMappingURL=#classification-rule-mapper.js.map